// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"09f5644c","598":"95c60409","1797":"ce5d4ed4","1988":"a6848ac1"}[chunkId] + ".chunk.css";
};